// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3l_Kw","dragIcon":"SortableItem_dragIcon__1wtxs","disabled":"SortableItem_disabled__RhiGo"};